import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-page-spinner',
  templateUrl: './page-spinner.component.html',
  styleUrls: ['./page-spinner.component.scss']
})
export class PageSpinnerComponent implements OnInit {

  @Input() loadText;

  constructor() { }

  ngOnInit(): void {
  }

}
